'use strict';

import angular from 'angular';
import FormController from 'app/controllers/form';

class WorkerController extends FormController {
    /* @ngInject */
    constructor(
        WorkersService,
        $scope,
        $mdDialog,
        $mdToast,
        $state,
        $location
    ) {
        let worker = $scope.$parent.$resolve.worker;
        super(
            worker,
            'Gestor calle',
            WorkersService,
            null,
            'workers'
        );

        Object.assign(this, {
            WorkersService,
            $mdDialog,
            $mdToast,
            $state,
            $location
        });
    }

    $onInit() {
        super.$onInit();
    }
}

export default WorkerController;
